export const SUPER_ADMIN_ROLE = "SuperAdmin";
export const ADMIN_ROLE = "Admin";
export const APPROVAL_ROLE = "Approval";
export const LICENSER_ROLE = "Licenser";
export const USER_ROLE = "User";
